/**
 * @example
 * // returns '6886'
 * getLinkIdFromAffiliateUrl('https://www.raiseright.com/affiliate/attribution?affiliateUrl=https%3A%2F%2Fcloud.flipgive.com%2Fintent%3FlinkId%3D6886%26web%3Dtrue%26isIntentLoader%3Dtrue%26token%3D%7B%7Btoken%7D%7D');
 */
export function getLinkIdFromAffiliateUrl(url: string): string {
  // use a regex to extract the linkId from the url, but exclude the url encoded %3D part of the sting
  const linkId = url.match(/linkId[%3D|=](\d+)/)?.[1] || '';
  return linkId || '';
}